import { useCallback } from 'react';
import { RowSelectionState, Updater } from '@tanstack/react-table';
import { isRowWithId } from '../utils';

interface UseGetSelectedRowOriginalDataProps<T> {
  data: T[];
}

export const useGetSelectedRowOriginalData = <T>({
  data,
}: UseGetSelectedRowOriginalDataProps<T>) =>
  useCallback(
    (
      updater: Updater<RowSelectionState>,
      currentState: RowSelectionState = {},
      currentSelectedRowsOriginalData: T[] = []
    ) => {
      const newSelection =
        typeof updater === 'function' ? updater(currentState) : updater;

      const selectedIds = Object.entries(newSelection)
        .filter(([_, value]) => value)
        .map(([key]) => key);

      const filteredOldValues = currentSelectedRowsOriginalData.filter(
        value => isRowWithId(value) && selectedIds.includes(value.id)
      ) as (T & { id: string })[];

      const newSelectedRows = (data || []).filter(
        row =>
          isRowWithId(row) &&
          selectedIds.includes(row.id) &&
          !filteredOldValues.some(value => value.id === row.id)
      );

      return [...filteredOldValues, ...newSelectedRows];
    },
    [data]
  );
